<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "4rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M53 9h-8.5a1.5 1.5 0 000 3H52v40H12V12h7.5a1.5 1.5 0 000-3H11a2 2 0 00-2 2v42a2 2 0 002 2h42a2 2 0 002-2V11a2 2 0 00-2-2z"/><path d="M25.05 15.47l5.45-5.38V41.5a1.5 1.5 0 003 0V10.12l5.44 5.44a1.5 1.5 0 002.12 0 1.49 1.49 0 000-2.12l-7.65-7.65a2 2 0 00-2.82 0L23 13.34a1.5 1.5 0 102.1 2.13z"/></svg>